import React from 'react';
import CustomizableDashboard from '../../../components/dashboard/CustomizableDashboard';
import { WIDGET_CATEGORIES } from '../../../components/dashboard/widgetRegistry';

/**
 * DataOps Dashboard Page
 * Full customizable dashboard with Presets and Customize functionality
 */
const DataOpsDashboardPage: React.FC = () => {
  return (
    <CustomizableDashboard
      title="Overview"
      description="Monitor your data pipelines, quality, and job executions"
      storageKey="dataops-dashboard-layout"
      context="dataops"
      widgetCategory={WIDGET_CATEGORIES.DATAOPS}
      useBackendPersistence={true}
      allowSetDefault={true}
    />
  );
};

export default DataOpsDashboardPage;
